import React from "react";
import styles from "./LogoSquare.module.scss";
import LazyImage from 'gui/components/LazyImage/LazyImage';


export interface IGenericImageSquareProps {
  logoSrc?: string | string[];
  logoTitle?: string;
}


const LogoSquare = (props: IGenericImageSquareProps) => (
  <div className={`LogoSquare ${styles.logoSquare} ${!props.logoSrc ? 'noLogo' : ''}`.trim()}>
    <LazyImage src={props.logoSrc}
               title={props.logoTitle}
    />
  </div>
);

LogoSquare.defaultProps = {
  logoSrc: "",
  logoTitle: "",
};

export default LogoSquare;
